import { openAdvisorView } from "./openAdvisorView";

type AdvisorViewLinkProps = {
    scope: "distro" | "advisor";
    id: string;
    title?: string;
    children: React.ReactNode;
};

const AdvisorViewLink = ({ scope, id, title, children }: AdvisorViewLinkProps) => {
    if (!id) return <>{children}</>;

    return (
        <button
            type="button"
            className="advisor-view-link"
            title={title}
            onClick={() => openAdvisorView(scope, id)}
        >
            {children}
        </button>
    );
};

export default AdvisorViewLink;
